import type { SliceTemplateProps } from '@yoweb/prismic-slicemachine/slices/slicesTypes';
import FaqSlice, { FaqSliceType } from '@yoweb/prismic-slicemachine/slices/FaqSlice';

export const PricingTemplate = ({ slice }: SliceTemplateProps) => {
  if (slice.slice_type === FaqSliceType) {
    return <FaqSlice background="sky" data-testid="faq-section" slice={slice} />;
  }
  return null;
};
